import kanbanReducer from './KanbanReducer';
import {
    SET_INITIAL_PROJECT,
    FETCH_CURRENT_PROJECT_REQUEST,
    FETCH_CURRENT_PROJECT_SUCCESS,
    FETCH_CURRENT_PROJECT_FAILURE,

    FETCH_PROJECTS_REQUEST,
    FETCH_PROJECTS_SUCCESS,
    FETCH_PROJECTS_FAILURE,

    CREATE_PROJECT_REQUEST,
    CREATE_PROJECT_SUCCESS,
    CREATE_PROJECT_FAILURE,

    SET_CURRENT_PROJECT_REQUEST,
    SET_CURRENT_PROJECT_SUCCESS,
    SET_CURRENT_PROJECT_FAILURE,

    UPDATE_PROJECT_REQUEST,
    UPDATE_PROJECT_SUCCESS,
    UPDATE_PROJECT_FAILURE,

    DELETE_PROJECT_REQUEST,
    DELETE_PROJECT_SUCCESS,
    DELETE_PROJECT_FAILURE,

    MOVE_PROJECT_RESOURCES_REQUEST,
    MOVE_PROJECT_RESOURCES_SUCCESS,
    MOVE_PROJECT_RESOURCES_FAILURE,

    // Kanban
    SET_PROJECT_STRUCTURE,

    PING_PROJECT_KANBAN_REQUEST,
    PING_PROJECT_KANBAN_SUCCESS,
    PING_PROJECT_KANBAN_FAILURE,

    SORT_KANBAN_REQUEST,
    SORT_KANBAN_SUCCESS,
    SORT_KANBAN_FAILURE,

    CREATE_SITE_CARD_COLUMN_REQUEST,
    CREATE_SITE_CARD_COLUMN_SUCCESS,
    CREATE_SITE_CARD_COLUMN_FAILURE,

    UPDATE_SITE_CARD_COLUMN_REQUEST,
    UPDATE_SITE_CARD_COLUMN_SUCCESS,
    UPDATE_SITE_CARD_COLUMN_FAILURE,

    DELETE_SITE_CARD_COLUMN_REQUEST,
    DELETE_SITE_CARD_COLUMN_SUCCESS,
    DELETE_SITE_CARD_COLUMN_FAILURE,

    MOVE_SITE_CARD_COLUMN_REQUEST,
    MOVE_SITE_CARD_COLUMN_SUCCESS,
    MOVE_SITE_CARD_COLUMN_FAILURE,

    EXPORT_PROJECT_COLUMN_REQUEST,
    EXPORT_PROJECT_COLUMN_SUCCESS,
    EXPORT_PROJECT_COLUMN_FAILURE,

    MOVE_SITE_CARD_REQUEST,
    MOVE_SITE_CARD_SUCCESS,
    MOVE_SITE_CARD_FAILURE,

    SORT_SITE_CARDS_REQUEST,
    SORT_SITE_CARDS_SUCCESS,
    SORT_SITE_CARDS_FAILURE,

    COLUMN_SCROLL_POSITION_UPDATE,
    KANBAN_SCROLL_POSITION_UPDATE,
} from './Types';
import { DELETE_SITE_CARD_SUCCESS } from '../site_card/Types';

import {CurrentProject, IProjectAction, IProjectReducerState, IColumnsScrollPosition, Structure} from "./projectTypes";
import _ from 'lodash';

const defaultState = {
    isFetchingProjects: false,
    fetchingProjectsError: null,
    isUpdatingProjectStructure: false,
    isCreatingProject: false,
    createProjectError: null,
    isSettingCurrentProject: false,
    isUpdatingProject: false,
    updateProjectError: null,
    isMovingResources: false,
    movingResourcesError: null,
    settingCurrentProjectError: null,
    projects: [],

    currentProject: null,
    isFetchingCurrentProject: false,
    fetchCurrentProjectError: null,
    isExporting: false,

    isDeletingColumn: false,
    isSortingKanban: false
};

export default function reducer (state:IProjectReducerState = defaultState, action:IProjectAction) {
    switch (action.type) {
        case MOVE_PROJECT_RESOURCES_REQUEST:
            return {
                ...state,
                isMovingResources: true
            };
        case MOVE_PROJECT_RESOURCES_SUCCESS:
            return {
                ...state,
                isMovingResources: false
            };
        case MOVE_PROJECT_RESOURCES_FAILURE:
            return {
                ...state,
                isMovingResources: false,
                movingResourcesError: action.error
            };

        case DELETE_PROJECT_REQUEST:
            return {
                ...state,
                isDeletingProject: true
            };
        case DELETE_PROJECT_SUCCESS:
            return {
                ...state,
                isDeletingProject: false
            };
        case DELETE_PROJECT_FAILURE:
            return {
                ...state,
                isDeletingProject: false,
                deleteProjectError: action.error
            };

        case UPDATE_PROJECT_REQUEST:
            return {
                ...state,
                isUpdatingProject: true
            };
        case UPDATE_PROJECT_SUCCESS:
            const updatedProjectIdx = state.projects.findIndex((p) => p.id === action.id);
            const updatedProjects = _.cloneDeep(state.projects);
            updatedProjects.splice(updatedProjectIdx, 1, action.project);
            return {
                ...state,
                isUpdatingProject: false,
                projects: [...updatedProjects]
            };
        case UPDATE_PROJECT_FAILURE:
            return {
                ...state,
                isUpdatingProject: false,
                updateProjectError: action.error
            };

        case SET_INITIAL_PROJECT:
            return {
                ...state,
                currentProjectId: action.id
            };
        case FETCH_PROJECTS_REQUEST:
            return {
                ...state,
                isFetchingProjects: true
            };
        case FETCH_PROJECTS_SUCCESS:
            return {
                ...state,
                projects: action.projects,
                fetchingProjectsError: null,
                isFetchingProjects: false
            };
        case FETCH_PROJECTS_FAILURE:
            return {
                ...state,
                fetchingProjectsError: action.error,
                isFetchingProjects: false
            };
        case FETCH_CURRENT_PROJECT_REQUEST:
            return {
                ...state,
                isFetchingCurrentProject: true,
                fetchingCurrentProjectError: null
            };
        case FETCH_CURRENT_PROJECT_SUCCESS:        
            return {
                ...state,
                currentProject: cleanCurrentProject(action.project),
                isFetchingCurrentProject: false,
                fetchingCurrentProjectError: null
            };
        case FETCH_CURRENT_PROJECT_FAILURE:
            return {
                ...state,
                fetchingCurrentProjectError: action.error,
                isFetchingCurrentProject: false
            };
        case CREATE_PROJECT_REQUEST:
            return {
                ...state,
                isCreatingProject: true
            };
        case CREATE_PROJECT_SUCCESS:
            return {
                ...state,
                projects: [...state.projects, action.project],
                createProjectError: null,
                isCreatingProject: false
            };
        case CREATE_PROJECT_FAILURE:
            return {
                ...state,
                createProjectError: action.error.data.message || action.error.statusText,
                isCreatingProject: false
            };
        case SET_CURRENT_PROJECT_REQUEST:
            return {
                ...state,
                isSettingCurrentProject: true
            };
        case SET_CURRENT_PROJECT_SUCCESS:
            // Remove sitecards from
            return {
                ...state,
                currentProject: cleanCurrentProject(action.project),
                settingCurrentProjectError: null,
                isSettingCurrentProject: false
            };
        case SET_CURRENT_PROJECT_FAILURE:
            return {
                ...state,
                settingCurrentProjectError: action.error.data.message || action.error.statusText,
                isSettingCurrentProject: false
            };
        
        // Kanban Columns
        case SET_PROJECT_STRUCTURE:
        case PING_PROJECT_KANBAN_REQUEST:
        case PING_PROJECT_KANBAN_SUCCESS:
        case PING_PROJECT_KANBAN_FAILURE:
        case SORT_KANBAN_REQUEST:
        case SORT_KANBAN_SUCCESS:
        case SORT_KANBAN_FAILURE:
        case CREATE_SITE_CARD_COLUMN_REQUEST:
        case CREATE_SITE_CARD_COLUMN_SUCCESS:
        case CREATE_SITE_CARD_COLUMN_FAILURE:
        case UPDATE_SITE_CARD_COLUMN_REQUEST:
        case UPDATE_SITE_CARD_COLUMN_SUCCESS:
        case UPDATE_SITE_CARD_COLUMN_FAILURE:
        case MOVE_SITE_CARD_COLUMN_REQUEST:
        case MOVE_SITE_CARD_COLUMN_SUCCESS:
        case MOVE_SITE_CARD_COLUMN_FAILURE:
        case DELETE_SITE_CARD_COLUMN_REQUEST:
        case DELETE_SITE_CARD_COLUMN_SUCCESS:
        case DELETE_SITE_CARD_COLUMN_FAILURE:
        case EXPORT_PROJECT_COLUMN_REQUEST:
        case EXPORT_PROJECT_COLUMN_SUCCESS:
        case EXPORT_PROJECT_COLUMN_FAILURE:
        case MOVE_SITE_CARD_REQUEST:
        case MOVE_SITE_CARD_SUCCESS:
        case MOVE_SITE_CARD_FAILURE:
        case SORT_SITE_CARDS_REQUEST:
        case SORT_SITE_CARDS_SUCCESS:
        case SORT_SITE_CARDS_FAILURE:
        case DELETE_SITE_CARD_SUCCESS:
        case COLUMN_SCROLL_POSITION_UPDATE:
        case KANBAN_SCROLL_POSITION_UPDATE:
            return kanbanReducer(state, action);
        default:
            return state;
    }
}

// Removes unnecessary fields from the current project for this reducer eg. Don't need sitecards here although part of object for sitecard reducer
function cleanCurrentProject (project: CurrentProject) {
    const { siteCards, ...otherProps } = project;
    return {
        ...otherProps
    };
}
